module.exports = __webpack_public_path__ + "static/media/reddit.3cf3576f.svg";